// Generated using https://github.com/workivate/AnalyticsGen
// Last update: 21/02/2025
// DO NOT EDIT

import AnalyticsSingletonFactory, {
  type Options,
} from '../../../common/analytics-engine';

export const AnalyticsEventsFactory = (options: Options) => {
  const Analytics = AnalyticsSingletonFactory(options);

  return {
    Login: {
      PasswordReset: {
        Forgotpasswordlink: {
          /** When a user clicks on Forgot password link on the login screen */
          forgotpasswordlinkclicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'PasswordReset_Forgotpasswordlink',
              action: 'Forgot password link clicked',
            }),
        },
      },
    },
  };
};
